import { useTranslation } from '../../../i18n';
import { Box } from '../../../box';
import { Highlighter, DragItem } from '../../component';
import { service } from '../service';
import styles from '../style.module.less';
import { usePrimaryColor } from '../../hooks';
import { RadioBoxComponent } from './radio';
import type { ReactElement } from 'react';
import type { RadioBoxProps } from './types';

export function RadioBoxDesignMode(props: RadioBoxProps): ReactElement {
  const [t] = useTranslation();

  const { rgbColor } = usePrimaryColor();
  if (props.name == null) {
    return (
      <DragItem title={t('RadioBox')} />
    );
  }

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={styles.input}>
        <RadioBoxComponent {...props} />
      </Box>
    </Box>
  );
}
